import NextHead from "next/head";
import { useTranslations } from "next-intl";
import { useRouter } from "@lib/i18n/navigation-pages-router";

// This component is used to set the title and meta description on the pages router only

const Head = () => {
  const t = useTranslations("common");

  const router = useRouter();
  const page = router?.pathname
    ?.split("/")
    ?.filter((pathPart) => !!pathPart)
    ?.join(".");

  const title = page && t.has(`meta.${page}.title`) ? t(`meta.${page}.title`) : t("meta.title");
  const description =
    page && t.has(`meta.${page}.description`)
      ? t(`meta.${page}.description`)
      : t("meta.description");

  return (
    <NextHead>
      <title key="title">{title}</title>
      <meta
        name="description"
        key="description"
        content={description}
      />
    </NextHead>
  );
};

export default Head;
